import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-photo-album',
  templateUrl: './photo-album.component.html',
  styleUrls: ['./photo-album.component.scss'],
  imports: [CommonModule]
})
export class PhotoAlbumComponent implements OnInit {

  @Input() photos = [];
  @Input() albumTitle = "Album";

  showViewer = false;
  currentImageIndex : number = 0;

  previewImageSrc = "";
  previewImageTitle = "";
  previewImageDescription = "";
  previewImageHeight = 400;
  previewImageWidth = 500;

  constructor() { }

  ngOnInit() {
  }

  showImage(photo: any): void {

    this.previewImageSrc = photo.src;
    this.previewImageTitle = photo.title;
    this.previewImageDescription = photo.description;
 
    if (this.previewImageWidth > window.innerWidth)
    {
      this.previewImageWidth = window.innerWidth - 70;

      var ratio = this.previewImageHeight / this.previewImageWidth;

      this.previewImageHeight = this.previewImageWidth * ratio;
    }

    this.showViewer = true;

  }




  closeImage(){
    this.showViewer = false;
    this.previewImageSrc = "";
    this.previewImageTitle = "";
    this.previewImageDescription = "";  
  }

}
